// src/Components/Chart_Support_Files/chartSymbolUtils.js

export function getStoreKey(symbol) {
  switch (symbol) {
    case 'SPX':
      return 'spx';

    default:
      return null;
  }
}

export function isMobileChart() {
  return window.innerWidth <= 768;
}